.hotkey {
	font-family: var(--font-mono);
	background-color: var(--color-border);
	padding: var(--size-1) var(--size-3);
	border-radius: var(--radius-md);
}

.label {
	display: flex;
	align-items: center;
	gap: var(--size-3);
}

.modalFooter {
	display: flex;
	justify-content: flex-end;
}
